import React, { useState, useEffect } from "react";
import { Modal, Tabs, Input, Button, Form, message } from "antd";
import { MailOutlined, WhatsAppOutlined } from "@ant-design/icons";
import { shareDischargeSummaryApi } from "../../../../services/discharge.services";
import styles from "./ShareModal.module.css";

const ShareModal = ({
  openModal,
  setOpenModal,
  id,
  practitioner,
  patientData,
}) => {
  const [emailForm] = Form.useForm(); // 👈 separate form for email
  const [whatsappForm] = Form.useForm(); // 👈 separate form for whatsapp
  const [loading, setLoading] = useState(false);
  const [activeTab, setActiveTab] = useState("email");
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const mq = window.matchMedia("(max-width: 768px)");
    const onChange = () => setIsMobile(mq.matches);
    onChange();
    mq.addEventListener("change", onChange);
    return () => mq.removeEventListener("change", onChange);
  }, []);

  const handleShare = async (values) => {
    setLoading(true);
    try {
      const payload = {
        practitioner: practitioner,
        type: activeTab,
        recipient: activeTab === "email" ? values.email : values.mobile,
      };

      const response = await shareDischargeSummaryApi(id, payload);
      message.success(response?.data?.message || "Shared successfully!");
      setOpenModal(false);
      emailForm.resetFields();
      whatsappForm.resetFields();
    } catch (error) {
      message.error(
        error?.response?.data?.message || "Failed to share. Please try again."
      );
    } finally {
      setLoading(false);
    }
  };

  const handleCancel = () => {
    setOpenModal(false);
    emailForm.resetFields();
    whatsappForm.resetFields();
  };

  const tabItems = [
    {
      key: "email",
      label: (
        <span>
          <MailOutlined style={{ marginRight: "10px" }} />
          Email
        </span>
      ),
      children: (
        <Form
          form={emailForm} // 👈
          layout="vertical"
          onFinish={handleShare}
          style={{ marginTop: 16 }}
          initialValues={{ email: patientData?.admission?.patient?.email }}
        >
          <Form.Item
            name="email"
            label="Email Address"
            rules={[
              { required: true, message: "Please enter email address" },
              { type: "email", message: "Please enter a valid email" },
            ]}
          >
            <Input
              placeholder="Enter email address"
              size="large"
              prefix={<MailOutlined />}
            />
          </Form.Item>
          <Form.Item style={{ marginBottom: 0, textAlign: "right" }}>
            <Button
              type="primary"
              htmlType="submit"
              loading={loading}
              size="large"
            >
              Share via Email
            </Button>
          </Form.Item>
        </Form>
      ),
    },
    {
      key: "whatsapp",
      label: (
        <span>
          <WhatsAppOutlined style={{ marginRight: "10px" }} />
          WhatsApp
        </span>
      ),
      children: (
        <Form
          form={whatsappForm} // 👈
          layout="vertical"
          onFinish={handleShare}
          style={{ marginTop: 16 }}
          initialValues={{ mobile: patientData?.admission?.patient?.mobile }}
        >
          <Form.Item
            name="mobile"
            label="Mobile Number"
            rules={[
              { required: true, message: "Please enter mobile number" },
              {
                pattern: /^[+]?[\d\s\-\(\)]+$/,
                message: "Please enter a valid mobile number",
              },
            ]}
          >
            <Input
              placeholder="Enter mobile number"
              size="large"
              prefix={<WhatsAppOutlined />}
            />
          </Form.Item>
          <Form.Item style={{ marginBottom: 0, textAlign: "right" }}>
            <Button
              type="primary"
              htmlType="submit"
              loading={loading}
              size="large"
              // style={{ backgroundColor: "#25D366", borderColor: "#25D366" }}
            >
              Share via WhatsApp
            </Button>
          </Form.Item>
        </Form>
      ),
    },
  ];
  // ...

  return (
    <Modal
      title="Share Discharge Summary"
      open={openModal}
      onCancel={handleCancel}
      footer={null}
      width={isMobile ? "min(92vw, 400px)" : 500}
      centered={isMobile}
      className={styles.shareModal}
      destroyOnClose
    >
      <Tabs
        defaultActiveKey="email"
        items={tabItems}
        onChange={(key) => {
          if (typeof setActiveTab === "function") setActiveTab(key);
        }}
        size={isMobile ? "middle" : "large"}
      />
    </Modal>
  );
};

export default ShareModal;
